import { InvestorDocumentWorkflowsRes } from '@dealstack/frontend/investor/pages/Documents/types';
import { ROUTES } from '@dealstack/frontend/investor/pages/Routing/routes';
import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { DocumentSignatureType, DocumentTemplateType } from '@dealstack/shared/lib/generated';
import { useMemo, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

interface SelectedDocumentToUploadOptions {
	combinedFile: InvestorDocumentWorkflowsRes['combinedFile'];
	documentSubmissionId: string;
	signatureType: DocumentSignatureType;
	templateType: DocumentTemplateType;
}

interface SelectedDocumentToReview {
	file: { id: string; name: string; createdAt?: string };
	dealId: string;
	templateType: DocumentTemplateType;
	documentSubmissionId: string;
}

interface DocumentsSidebarConfigItem {
	key: number;
	title: string;
	route?: string;
}
export const useDocumentsController = () => {
	const [selectedDocument, setSelectedDocument] = useState<SelectedDocumentToReview>();
	const [selectedDocumentToUploadDocument, setSelectedDocumentToUploadDocument] =
		useState<SelectedDocumentToUploadOptions>();

	const { investorId, dealId, mipId } = useParams();

	const navigate = useNavigate();
	const { pathname } = useLocation();

	const tInvestor = useTranslationInvestor();

	if (!investorId) {
		navigate('/');
	}

	const closeUploadModal = () => {
		setSelectedDocumentToUploadDocument(undefined);
	};

	const documentsPageSideBarConfig = useMemo((): DocumentsSidebarConfigItem[] => {
		return [
			{
				title: tInvestor('documents.side_bar.all_documents'),
				key: 0,
				route: ROUTES.DOCUMENTS.replace(':dealId', `${dealId}`)
					.replace(':mipId', `${mipId}`)
					.replace(':investorId', `${investorId}`),
			},
		];
	}, [investorId, dealId, mipId]);

	const redirectLink = useMemo(() => {
		let pathName = ROUTES.DASHBOARD.toString();
		if (investorId) {
			pathName = ROUTES.VALUATIONS.replace(':investorId', `${investorId}`);
		}
		return pathName;
	}, [investorId]);

	const activeMainStep = useMemo(
		() =>
			documentsPageSideBarConfig?.find((step) => step.route && pathname.includes(step.route)),
		[pathname, documentsPageSideBarConfig]
	);

	return {
		redirectLink,
		selectedDocument,
		setSelectedDocument,
		selectedDocumentToUploadDocument,
		closeUploadModal,
		activeMainStep,
		documentsPageSideBarConfig,
	};
};
